import { useMemo } from 'react';
import classNames from 'classnames';

type PortalEmpleoInfoProps = {
	readonly className?: string;
};

const classNameComponent = 'c-cnm-section-intro';

export const PortalEmpleoInfo = ({ className }: PortalEmpleoInfoProps) => {
	const wrapperClassName = classNames(classNameComponent, className);
	return (
		<div className={`${wrapperClassName} o-strapi-page u-mt-16`}>
			<h3>Información para colegiados.</h3>
			<p className="u-mb-8">
				Los colegiados interesados en el servicio de intermediación en la búsqueda de empleados para sus
				notarías deben enviar la ficha de oferta de empleo (aquí) debidamente cumplimentada a
				portaldeempleo@madrid.notariado.org.
			</p>
			<p className="u-mb-8">
				La oferta se publicará por un tiempo determinado en el Portal de Empleo accesible a través de la web del
				Colegio Notarial de Madrid. Finalizado el plazo establecido en cada oferta se remitirán al notario
				anunciante los CVs de los candidatos que se hayan inscrito y se dará por finalizado el servicio de
				intermediación.
			</p>

			<h3 className="u-mt-16">Características del servicio.</h3>
			<p>
				<em>Gratuito</em>: no implica ningún coste para el notario anunciante.
			</p>
			<p>
				<em>Confidencial</em>: se garantiza total confidencialidad durante todo el proceso, evitando cualquier
				filtración o información sensible.
			</p>
			<p>
				<em>Sin compromiso de exclusividad</em>: el notario anunciante puede buscar candidatos/as de forma
				simultánea por cualquier otra vía que considera oportuna.
			</p>
			<p>
				<em>Sin compromiso de contratación:</em> Línea 4. Estación: Manoteras
			</p>

			<h3>Información para colegiados.</h3>
			<p className="u-mb-8">
				El Portal de Empleo del Colegio Notarial de Madrid únicamente publica las ofertas que le remiten sus
				colegiados. En estas ofertas se especifica el nombre del puesto, las funciones del mismo y los
				requisitos que se exigen en cuanto a formación, experiencia y otras características (idiomas, ofimática,
				etc.).
			</p>
			<p className="u-mb-8">
				Los candidatos pueden hacer uso del Portal de Empleo inscribiéndose en las ofertas publicadas que le
				interesen mediante un formulario en el que adjuntarán su CV y autorizarán la cesión de datos a los
				oferentes de empleo.
			</p>
			<p className="u-mb-8">
				Las ofertas tienen una fecha límite hasta la cual los candidatos pueden inscribirse. Pasada esa fecha el
				Portal de Empleo envía los CVs recibidos al notario ofertante, dando por terminado el servicio de
				intermediación. Una vez enviados los CVs es el notario el que continúa el proceso de selección de forma
				independiente del Colegio.
			</p>
		</div>
	);
};
